import { locale as landingSearch } from '@landing/components/landing-search/i18n/en';
import { locale as landingBanner } from '@landing/components/landing-banner/i18n/en';
import { locale as landingSection } from '@landing/components/landing-section/i18n/en';
import { locale as landingPage } from '@landing/pages/landing/i18n/en';
import { locale as landingAppointmentCard } from '@landing/components/landing-appointment-card/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...landingPage.data,
        ...landingSearch.data,
        ...landingBanner.data,
        ...landingSection.data,
        ...landingAppointmentCard.data,
    }
};